window.addEventListener('load', function() {
  // Pixel tracker
  const teadsScript = document.createElement('script');
  teadsScript.async = true;
  teadsScript.src = 'https://p.teads.tv/teads-fellow.js';
  teadsScript.type = 'text/javascript';
  document.head.appendChild(teadsScript);

  window.teads_e = window.teads_e || [];
  window.teads_buyer_pixel_id = 11079;

  // // Facebook Pixel Code
  // !function(f,b,e,v,n,t,s)
  // {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  // n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  // if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  // n.queue=[];t=b.createElement(e);t.async=!0;
  // t.src=v;s=b.getElementsByTagName(e)[0];
  // s.parentNode.insertBefore(t,s)}(window,document,'script',
  // 'https://connect.facebook.net/en_US/fbevents.js');
  // fbq('init', '612497876302287');
  // fbq('track', 'PageView');

  // Insert noscript pixel
  // const noscriptPixelFacebook = document.createElement('noscript');
  // const imgPixelFacebook = document.createElement('img');
  // imgPixelFacebook.alt = "facebook";
  // imgPixelFacebook.height = "1";
  // imgPixelFacebook.width = "1";
  // imgPixelFacebook.style.display = "none";
  // imgPixelFacebook.src = "https://www.facebook.com/tr?id=612497876302287&ev=PageView&noscript=1";
  // noscriptPixelFacebook.appendChild(imgPixelFacebook);
  // document.body.appendChild(noscriptPixelFacebook);

  // TikTok Pixel Code
  !function (w, d, t) {
    w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(
    var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var r="https://analytics.tiktok.com/i18n/pixel/events.js",o=n&&n.partner;ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=r,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};n=document.createElement("script")
    ;n.type="text/javascript",n.async=!0,n.src=r+"?sdkid="+e+"&lib="+t;e=document.getElementsByTagName("script")[0];e.parentNode.insertBefore(n,e)};
    ttq.load('CV2QIQJC77U54LNIFVOG');
    ttq.page();
  }(window, document, 'ttq');
});
